<template>
  <v-navigation-drawer
    v-model="drawerValue"
    color="#fafafa"
    width="248"
    floating
    app
    class="app-drawer">
    <div class="app-drawer__brand">
      <img
        alt="Vadimm"
        src="/vadimm-logo.svg"
        width="22">
      <span>vadimm<b>.</b></span>
      <span class="app-drawer__tag">admin</span>
    </div>

    <div class="app-drawer__env">
      <env-switch />
    </div>

    <nav class="app-drawer__nav">
      <div
        v-for="group in sections"
        :key="group.section"
        class="app-drawer__group">
        <div class="app-drawer__section">
          {{ group.section }}
        </div>
        <router-link
          v-for="item in group.items"
          :key="item.route"
          :to="{ name: item.route }"
          class="app-drawer__link"
          :class="{ 'is-active': $route.name === item.route }"
          active-class=""
          exact-active-class="">
          <v-icon size="18">
            {{ item.icon }}
          </v-icon>
          <span>{{ item.title }}</span>
        </router-link>
      </div>
    </nav>

    <template #append>
      <div class="app-drawer__user">
        <div class="app-drawer__avatar">
          {{ initials }}
        </div>
        <div class="app-drawer__user-info">
          <div class="app-drawer__user-name">
            {{ currentUser.first_name }} {{ currentUser.last_name }}
          </div>
          <div class="app-drawer__user-mail">
            {{ currentUser.email }}
          </div>
        </div>
        <v-btn
          icon
          small
          title="Déconnexion"
          @click="$emit('logout')">
          <v-icon size="18">
            mdi-logout
          </v-icon>
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
  import { mapState } from 'vuex'
  import sections from '../navItems'
  import EnvSwitch from './EnvSwitch'

  export default {
    name: 'AppDrawer',
    components: { EnvSwitch },
    data () {
      return {
        sections
      }
    },
    computed: {
      ...mapState(['currentUser']),
      initials () {
        const { first_name: first, last_name: last } = this.currentUser
        return `${(first || '')[0] || ''}${(last || '')[0] || ''}`.toUpperCase()
      },
      drawerValue: {
        get () {
          return this.$store.state.drawer
        },
        set (val) {
          this.$store.commit('setDrawer', val)
        }
      }
    }
  }
</script>

<style scoped>
  .app-drawer {
    border-right: 1px solid #f0f0f2 !important;
  }
  .app-drawer__brand {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 64px;
    padding: 0 22px;
    font-weight: 800;
    font-size: 19px;
    letter-spacing: -0.5px;
  }
  .app-drawer__brand b {
    color: #7c6cf2;
  }
  .app-drawer__tag {
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: 0.3px;
    color: #7a7a85;
    background: #efeff1;
    border-radius: 6px;
    padding: 2px 6px;
  }
  .app-drawer__env {
    padding: 0 14px 6px;
  }
  .app-drawer__nav {
    padding: 4px 14px 16px;
  }
  .app-drawer__section {
    padding: 16px 10px 6px;
    font-size: 12px;
    font-weight: 500;
    color: #a1a1aa;
  }
  .app-drawer__link {
    display: flex;
    align-items: center;
    gap: 11px;
    height: 36px;
    padding: 0 11px;
    margin-bottom: 1px;
    border-radius: 10px;
    color: #2b2b31;
    font-size: 13.5px;
    font-weight: 500;
    text-decoration: none;
  }
  .app-drawer__link .v-icon {
    color: #71717a;
  }
  .app-drawer__link:hover {
    background: #f1f1f3;
  }
  .app-drawer__link.is-active {
    background: white;
    color: #111113;
    font-weight: 700;
    box-shadow: inset 0 0 0 1.5px #111113;
  }
  .app-drawer__link.is-active .v-icon {
    color: #111113;
  }
  .app-drawer__user {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 0 14px 14px;
    padding: 12px 4px 0;
    border-top: 1px solid #ececef;
    font-size: 13px;
  }
  .app-drawer__avatar {
    flex: none;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #111113;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 12px;
  }
  .app-drawer__user-info {
    flex: 1;
    min-width: 0;
  }
  .app-drawer__user-name {
    font-weight: 700;
  }
  .app-drawer__user-mail {
    color: #7a7a85;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
